import Caption from './Caption'

export default Caption



// WEBPACK FOOTER //
// ./src/components/Captions/index.js